import countries from "./db/countries";
import providedProducts from "./db/providedProducts";

export default {
    namespaced: true,
    modules: {
        countries,
        providedProducts,
    }
}